import store from "@/store/index";
import moment from "moment";

export const dateInRange = (value, ruleProperty, units) => {
  const { MinValue, MaxValue, ErrorMsg, CompareUnits, Inclusivity } =
    ruleProperty;
  const userValue = moment(value, "DD/MM/YYYY", true);
  const minRange = MinValue ? moment().subtract(MinValue, units) : moment();
  const maxRange = MaxValue ? moment().add(MaxValue, units) : moment();

  const isInRange = moment(userValue).isBetween(
    moment(minRange),
    moment(maxRange),
    CompareUnits,
    Inclusivity
  );

  if (!value) {
    return true;
  } else {
    if (isInRange) {
      return true;
    } else {
      return `${ErrorMsg}`;
    }
  }
};

export const policyStartDateInRange = (value, ruleProperty) => {
  if (!value) return true;

  const { ErrorMsg } = ruleProperty;
  const userValue = moment(value, "DD/MM/YYYY", true);
  const today = moment().startOf("day");
  const expiryDateFromState =
    store.getters["application/selectedQuote"].QuoteExpiryDate;
  const expiryDate = moment(expiryDateFromState);

  const isInRange = userValue.isBetween(today, expiryDate, "day", "[]");

  if (isInRange) {
    return true;
  } else {
    return `${ErrorMsg + expiryDate.format("DD/MM/YY")}.`;
  }
};

export const ruleDateOfClaimInRange = (value, ruleProperty) => {
  if (!value) return true;

  const { ErrorMsg } = ruleProperty;
  const userValue = moment(value, "DD/MM/YYYY", true);
  const minRange = moment().subtract(5, "years");
  const maxRange = moment().subtract(1, "days"); // yesterday - exclude today

  const isInRange = moment(userValue).isBetween(
    moment(minRange),
    moment(maxRange),
    "days",
    "[]"
  );

  if (!value) {
    return true;
  } else {
    if (isInRange) {
      return true;
    } else {
      return `${ErrorMsg}`;
    }
  }
};
